import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  submitCorporateAndOrgStructureFailure,
  submitCorporateAndOrgStructureRequest,
} from "../../../../store/features/actions/corporateAndOrgStructureActions";
import { transformResultsToTableData } from "../../../../services/commonService";
import TopRightActionLinks from "../TopRightActionLinks";
import InsightTable from "../InsightTable";
import GenericOverviewSideCard from "../../genericComponents/GenericOverviewSideCard";

function CompanyOverview({ companyOverviewData }) {
  const [tabData, setTabData] = useState([]);
  const [showMoreModal, setShowMoreModal] = useState(false);
  const [showConversationModal, setShowConversationModal] = useState(false);

  const actions = [
    // { type: "chart", title: "Chart", onClick: () => {} },
    {
      type: "conversation",
      title: "Conversation",
      onClick: () => {
        setShowConversationModal((prev) => !prev);
      },
    },
    { type: "mindMap", title: "Mind Map", onClick: () => {} },
    { type: "download", title: "Download", onClick: () => {} },
  ];

  // const dummyData = [
  //   {
  //     competitor: "a",
  //     description: "b",
  //     focus: "c",
  //     ownership: "d",
  //     market_cap: "e",
  //     headquarters: "f",
  //     founded: "g",
  //     description_positive_insight: "b",
  //     description_negative_insight: "b",
  //     description_recent_development: "b",
  //     focus_positive_insight: "c",
  //     focus_negative_insight: "c",
  //     focus_recent_development: "c",
  //     ownership_positive_insight: "d",
  //     ownership_negative_insight: "d",
  //     ownership_recent_development: "d",
  //     market_cap_positive_insight: "e",
  //     market_cap_negative_insight: "e",
  //     market_cap_recent_development: "e",
  //     headquarters_positive_insight: "f",
  //     headquarters_negative_insight: "f",
  //     headquarters_recent_development: "f",
  //     founded_positive_insight: "g",
  //     founded_negative_insight: "g",
  //     founded_recent_development: "g",
  //   },
  //   {
  //     competitor: "h",
  //     description: "i",
  //     focus: "j",
  //     ownership: "k",
  //     market_cap: "l",
  //     headquarters: "m",
  //     founded: "n",
  //     description_positive_insight: "b",
  //     description_negative_insight: "b",
  //     description_recent_development: "b",
  //     focus_positive_insight: "c",
  //     focus_negative_insight: "c",
  //     focus_recent_development: "c",
  //     ownership_positive_insight: "d",
  //     ownership_negative_insight: "d",
  //     ownership_recent_development: "d",
  //     market_cap_positive_insight: "e",
  //     market_cap_negative_insight: "e",
  //     market_cap_recent_development: "e",
  //     headquarters_positive_insight: "f",
  //     headquarters_negative_insight: "f",
  //     headquarters_recent_development: "f",
  //     founded_positive_insight: "g",
  //     founded_negative_insight: "g",
  //     founded_recent_development: "g",
  //   },
  // ];

  useEffect(() => {
    const transformed = transformResultsToTableData(companyOverviewData);
    setTabData(transformed);
  }, [companyOverviewData]);

  const tableColumns = [
    { key: "description", label: "Description", width: "" },
    { key: "focus", label: "Focus", width: "" },
    { key: "ownership", label: "Ownership", width: "" },
    { key: "market_cap", label: "Market Cap", width: "100px" },
    { key: "headquarters", label: "Headquarters" },
    { key: "founded", label: "Founded", width: "90px" },
  ];

  const filtersConfig = [
    {
      key: "region",
      label: "Region",
      type: "dropdown", // 'dropdown' or 'chips'
      options: ["All", "EMEA", "NA", "APAC"],
      defaultValue: "All",
    },
    {
      key: "segment",
      label: "Segment",
      type: "chips",
      options: ["Retail", "Industrial", "Healthcare"],
      defaultValue: [], // for chips start empty
    },
  ];

  return (
    <div>
      <div className="company_overview_wrapper">
        <InsightTable
          title="Company Overview"
          data={tabData}
          metrics={tableColumns}
          rowIdentifier="competitor"
          actions={actions}
          filtersConfig={filtersConfig}
        />
      </div>

      <GenericOverviewSideCard
        showMoreModal={showConversationModal}
        setShowMoreModal={setShowConversationModal}
        titleForSideCard={<h5>AI Conversation</h5>}
        comp={<div className="p-3">Ai conversation</div>}
        minWidthForDrawer="30%"
        disableXbtn={true}
      />

      {/* <HorizontalBarChart /> */}
    </div>
  );
}

export default CompanyOverview;
